import React from "react";

interface CrossIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CrossIcon: React.FC<CrossIconProps> = ({ width = 17, height = 16, color = "#595A61" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.8335 12.6667L13.1668 3.33337" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.1668 12.6667L3.8335 3.33337" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CrossIcon;
